import { useFlags } from "features/api/flags"

export function useIsLoyaltyDrawerEnabled(): boolean {
  const { ENABLE_LOYALTY_DRAWER } = useFlags()
  return ENABLE_LOYALTY_DRAWER.boolVal
}
